module.exports = __webpack_public_path__ + "img/icon_order_blue.03b5f2ce.svg";